



































helpers = require('../../../helpers.coffee')

view_model = {
  props: ['task', 'options', 'origem']

  data: ->
    current_user: Session.current_user
    tooltip_text: @task.comment
    element_options:
      show_date: false
      show_contact: true
      show_comment: true
      icon_position: 'text' # 'item' available
      padding: 'sm' # 'lg' available

  watch:
    task: (new_value, old_value) ->
      @$refs.element_id.setAttribute('data-original-title', new_value.comment)

  created: ->
    @tasks_resources = new TasksResource
    @mergeDefaultOptions()

  mounted: ->
    Tooltip.initialize()
}

exports.default = helpers.vue_include(view_model, helpers.manual_tasks.list_item_wrapper, helpers.form, helpers.filters)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/done_tasks/list_item.vue